export class ProMeasurementDetailVariableEntity{
    id:number;
    measurementDetailId:number;
    variableId:number;
    variable:string;
    value:number;

    constructor(){}
}